import {z} from 'zod';

import {InspectionTypeConfig, ScopeValues} from '@dms/api/shared';

const MATCH_VALUES = ['every', 'some'] as const satisfies InspectionTypeConfig['match'][];

const inspectionParamsSchema = z.object({
  inspectionType: z.union([
    z.string(),
    z.enum(['SKIP']),
    z.object({
      match: z.enum(MATCH_VALUES),
      values: z.array(z.string()),
    }),
  ]),
});

export function evaluateInspectionType(scopes: string[], evaluatorParams: ScopeValues) {
  const {inspectionType} = validateInspectionEvaluatorParams(evaluatorParams);

  if (typeof inspectionType === 'string') {
    if (inspectionType === 'SKIP') {
      return true;
    }
    return scopes.includes(inspectionType);
  }

  if (inspectionType.match === 'every') {
    return inspectionType.values.every((type) => scopes.includes(type));
  }

  return inspectionType.values.some((type) => scopes.includes(type));
}

export function validateInspectionEvaluatorParams(evaluatorParams: ScopeValues | null) {
  return inspectionParamsSchema.parse(evaluatorParams);
}
